import React from 'react';
import AppLayout from '../../layouts/app/AppLayout';
import AppIcons from '../../assets/images/icons';
import { translateThis } from '../../helpers/language.helper';
import './custom.scss';




const ObjectivesPage = () => {
    // custom home functions here
    const pageName = "Objectives";

    const objectiveList1 = [
        { title: 'objectiveItem1' },
        { title: 'objectiveItem2' },
        { title: 'objectiveItem3' },
        { title: 'objectiveItem4' },
        { title: 'objectiveItem5' },
        { title: 'objectiveItem6' },
        { title: 'objectiveItem7' },
        { title: 'objectiveItem8' },
        { title: 'objectiveItem9' },
        { title: 'objectiveItem10' },
    ];
    const objectiveList2 = [
        { title: 'objectiveItem11' },
        { title: 'objectiveItem12' },
        { title: 'objectiveItem13' },
        { title: 'objectiveItem14' },
        { title: 'objectiveItem15' },
        { title: 'objectiveItem16' },
        { title: 'objectiveItem17' },
        { title: 'objectiveItem18' },
        { title: 'objectiveItem19' },
        { title: 'objectiveItem20' },
    ];
    const objectiveList3 = [
        { title: 'objectiveItem21' },
        { title: 'objectiveItem22' },
        { title: 'objectiveItem23' },
        { title: 'objectiveItem24' },
        { title: 'objectiveItem25' },
        { title: 'objectiveItem26' },
        { title: 'objectiveItem27' },
        { title: 'objectiveItem28' },
        { title: 'objectiveItem29' },
        { title: 'objectiveItem30' },
    ];

    return (
        <AppLayout
            pageName={pageName}
        >

            <div className="main-content-wrapper objective-main-wrapper f-wrp">
                <div className='objective-banner-wrapper f-wrp'>
                    <div className='main-container-wrp'>
                        <div className='banner-content-wrp f-wrp'>
                            <div className='row'>
                                <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                                    <div className='banner-content-box f-wrp'>
                                        <div className='content-main-box f-wrp'>
                                            <h1>{translateThis("Strategic")}<b>{translateThis("goals")}</b>{translateThis("for sustainable impact")}</h1>
                                            <p>{translateThis("objectiveBannerPara")}</p>
                                        </div>
                                        <div className='content-sub-box f-wrp'>
                                            <div className='each-content-box donation f-wrp'>
                                                <p>{translateThis("Donations")}</p>
                                                <h2>{translateThis("870K")}</h2>
                                                <p>{translateThis("donationsText")}</p>
                                            </div>
                                            <div className='each-content-box campaigns f-wrp'>
                                                <p>{translateThis("Campaigns")}</p>
                                                <h2>{translateThis("480+")}</h2>
                                                <p>{translateThis("campaignsText")}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                                    <div className='banner-img-sec f-wrp'>
                                        <span className='banner-main-img'><img src={AppIcons.objectivesBanner} alt='about us' /></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='objective-content-wrapper f-wrp'>
                    <div className='main-container-wrp'>
                        <div className='obj-content-boxes f-wrp'>
                            <div className='each-content-box f-wrp'>
                                <ul>
                                    {objectiveList1.map((element, key) => (
                                        <li key={key}>
                                            <p>{translateThis(element.title)}</p>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className='each-content-box f-wrp'>
                                <ul>
                                    {objectiveList2.map((element, key) => (
                                        <li key={key}>
                                            <p>{translateThis(element.title)}</p>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className='each-content-box f-wrp'>
                                <ul>
                                    {objectiveList3.map((element, key) => (
                                        <li key={key}>
                                            <p>{translateThis(element.title)}</p>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

















            </div>
        </AppLayout>
    )
}

export default ObjectivesPage;